import { Injectable } from '@angular/core';

@Injectable()
export class MathematicalHelperService {
  precisionRound(number, precision) {
    const factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }

  getMaxValue(propertyName: string, arr: Array<any>) {
    return Math.max.apply(Math, arr.map(function (i) { return i[propertyName]; }));
  }

  getSumOfAll(propertyName: string, arr: Array<any>): number {
    return arr.map(function (i) { return i[propertyName]; }).reduce((a, b) => a + b, 0);
  }
}
